import * as Utils from '@ext/index';

export class Estados
{

    constructor( id: string, descripcion: string )
    {
        this.Id = id;
        this.Descripcion = descripcion;
    }

    public readonly Id: string;
    public readonly Descripcion: string;

    public static toTipo( id: string ): Estados
    {

        if ( id === this.Activa.Id ) return this.Activa;
        else if ( id === this.Pausada.Id ) return this.Pausada;
        else if ( id === this.Cerrada.Id ) return this.Cerrada;

        return this.NoEspecificado;
    }

    public static Activa: Estados = new Estados( "activa", "Activa" );
    public static Pausada: Estados = new Estados( "pausada", "Pausada" );
    public static Cerrada: Estados = new Estados( "cerrada", "Cerrada" );
    public static NoEspecificado: Estados = new Estados( "no-especificado", "No especificado" );

    public get esActiva(): boolean { return this.Id === Estados.Activa.Id; }
    public get esPausada(): boolean { return this.Id === Estados.Pausada.Id; }
    public get esCerrada(): boolean { return this.Id === Estados.Cerrada.Id; }

    public static Filter = [
        { Id: 0, Nombre: 'Todos', Valor: [] },
        { Id: 1, Nombre: Estados.Activa.Descripcion, Valor: [Estados.Activa] },
        { Id: 2, Nombre: Estados.Pausada.Descripcion, Valor: [Estados.Pausada] },
        { Id: 3, Nombre: Estados.Cerrada.Descripcion, Valor: [Estados.Cerrada] },
    ];
}